import { h } from 'preact';
import * as BaseComp from 'components/shared/gmap/gmap.js';
// import s from 'components/shared/gmap/gmap.sss';
import { accessNested } from 'utils/utils';

export default class Gmap extends BaseComp.default {

	getTheaterLogoSrc(theater) {
		return accessNested(this.props, 'appData.urls.roots.sharedImages') +
			'/logos/light/' + (accessNested(theater, 'exhibitor.logo', 'default.png') || 'default.png');
	}

}

export const dependencies = BaseComp.dependencies;
